<p-toolbar class="w-full" styleClass="dark:bg-surface-950" [style]="{border: 0}">
    <ng-template #start>
        <app-logo class="ml-2"></app-logo>
    </ng-template>
    <ng-template #center>
        <app-title></app-title>
        <app-header-downtime></app-header-downtime>
    </ng-template>
    <ng-template #end>
        @if (authenticated()) {
            <app-user-info class="mr-3"></app-user-info>
            <app-help></app-help>
            <app-preferences></app-preferences>
        }
        @else {
            <app-logo class="mr-2" display="hide"></app-logo>
        }
    </ng-template>
</p-toolbar>



